/* tslint:disable */
/* eslint-disable */
/**
 * Befunde API
 * Internal API of befunde-ui for searching and downloading Befunde and for managing accounts, users and themes. The lab-transmitter uploads Befunde through it as well.
 *
 * The version of the OpenAPI document: 0.0.0
 * Contact: support@medcom.at
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const LabResultState = {
    InProgress: 'IN_PROGRESS',
    PartialResult: 'PARTIAL_RESULT',
    EndResult: 'END_RESULT',
    OrderReceived: 'ORDER_RECEIVED',
    SpecimenReceived: 'SPECIMEN_RECEIVED'
} as const;

export type LabResultState = typeof LabResultState[keyof typeof LabResultState];



